module.exports = "<label class=\"kng-switch pull-right\" [ngClass]=\"{'on': on}\">\r\n  <input type=\"checkbox\" class=\"hidden\" (click)=\"toggle($event)\">\r\n  <i class=\"kng-switch-indicator\"></i>\r\n</label>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/layout/kingswell/kng-switch/kng-switch.component.html
// module id = ../../../../../src/app/layout/kingswell/kng-switch/kng-switch.component.html
// module chunks = main